import { useCallback } from "react";
import { PlaidConnection } from "@common/types/plaidConnection";
import {
    useAddPlaidAccountsMutation,
    usePlaidConnectionFixingMutation,
} from "@mutations/plaidConnection";
import { ConnectionFix } from "@components/financialConnection/useOAuthConnectionFix";

export function usePlaidConnectionFix({
    connection,
    isAccountChurned,
    onFixed,
}: {
    connection: PlaidConnection;
    isAccountChurned?: boolean;
    onFixed?: () => void;
}): ConnectionFix {
    const fixAccount = usePlaidConnectionFixingMutation(connection, onFixed);
    const addAccounts = useAddPlaidAccountsMutation(onFixed);

    const startFix = useCallback(() => {
        if (isAccountChurned) {
            addAccounts.mutate(connection);
        } else {
            fixAccount.mutate();
        }
    }, [isAccountChurned, addAccounts, connection, fixAccount]);

    return {
        startFix,
        isFixing: fixAccount.isPending || addAccounts.isPending,
    };
}
